import './ChapterCircle.scss';
import Component from './ChapterCircle.js';
export default Component;
